var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07216 15.5833C3.76881 17.4223 3.44033 18.393 3.8071 19.1726C3.84345 19.2498 3.886 19.3244 3.93439 19.3956C4.4584 20.1666 5.81268 20.1666 8.52124 20.1666H13.4788C16.1873 20.1666 17.5416 20.1666 18.0656 19.3956C18.114 19.3244 18.1565 19.2498 18.1929 19.1726C18.5597 18.393 18.2317 17.4223 16.9284 15.5833",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9149 6.41675H10.0851C7.45432 6.41675 5.68061 9.23009 6.71692 11.7591C6.86128 12.1114 7.19249 12.3398 7.55896 12.3398H8.20336C8.42057 12.3398 8.6099 12.4944 8.66258 12.7148L9.4922 16.1854C9.66517 16.9091 10.2869 17.4167 11 17.4167C11.7132 17.4167 12.3349 16.9091 12.5078 16.1854L13.3374 12.7148C13.3901 12.4944 13.5795 12.3398 13.7967 12.3398H14.4411C14.8076 12.3398 15.1388 12.1114 15.2831 11.7591C16.3194 9.23009 14.5457 6.41675 11.9149 6.41675Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2916 4.12492C13.2916 5.39057 12.2656 6.41659 11 6.41659C9.73434 6.41659 8.70831 5.39057 8.70831 4.12492C8.70831 2.85927 9.73434 1.83325 11 1.83325C12.2656 1.83325 13.2916 2.85927 13.2916 4.12492Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowIcon);
export default __webpack_public_path__ + "static/media/follow_icon.9fa0f34baee8ea5a2ac557f201b0ee54.svg";
export { ForwardRef as ReactComponent };